<template>
  <el-dialog
    :title="dialogTitle"
    append-to-body
    :visible="dialogVisible"
    :close-on-click-modal="false"
    center
    width="80%"
    @close="closeDialog"
  >
    <sirui-search
      ref="siruiSearch"
      :query="dialogQuery"
      :columns="topColumn"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    ></sirui-search>
    <sirui-table
      ref="siruiTable"
      @handleSelectionChange="handleSelectionChange"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :data="tableData"
      :paging="true"
      :setting="false"
      :customVisible="false"
      :columns="columnList"
      :cellClick="cellClick"
      :cellStyle="cellStyle"
    >
      <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in columnList"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.field"
        :title="item.title ? $t(item.title) : null"
        :visible="item.visible"
        :type="item.type"
        :width="item.width"
      >
      </vxe-table-column>
    </sirui-table>
    <span slot="footer" class="dialog-footer" v-if="tableData.length > 0">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="sureRelated">确认关联</el-button>
    </span></el-dialog
  >
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { dialogSearchColumns, auditStatusList, contractStatusList } from '../data';
  import API from '@/api/property/leaseContract';
  import XEUtils from 'xe-utils';
  export default {
    name: 'relatedContractDialog',
    props: ['dialogVisible', 'dialogTitle', 'contractId'],
    components: {
      SiruiSearch,
    },
    computed: {
      topColumn() {
        return dialogSearchColumns();
      },
      columnList() {
        return [
          {
            field: 'contractNo',
            title: '合同编号',
            visible: true,
          },
          {
            field: 'contractName',
            title: '合同名称',
            visible: true,
          },
          {
            field: 'signPartyName',
            title: '签约方',
            visible: true,
          },
          {
            field: 'customerName',
            title: '客户名称',
            visible: true,
          },
          {
            field: 'leaseDuration',
            title: '租赁期限',
            visible: true,
          },
          {
            field: 'auditStatusName',
            title: '审核状态',
            visible: true,
          },
          {
            field: 'contractStatusName',
            title: '合同状态',
            visible: true,
          },
          {
            field: 'createPersonName',
            title: '创建人',
            visible: true,
          },
          {
            field: 'gmtCreate',
            title: '创建时间',
            visible: true,
          },
        ];
      },
    },
    mounted() {
      this.$nextTick(() => {
        if (this.contractId) {
          this.getData();
        }
      });
    },
    data() {
      return {
        dialogQuery: {
          contractCategory: '',
          contractNo: '',
          customerName: '',
          signPartyName: '',
        },
        multipleSelection: [],
        tableData: [],
        auditStatusList,
        contractStatusList,
        // checkedRowKeys: [],
      };
    },
    methods: {
      closeDialog() {
        this.$emit('close');
      },
      // 关联合同 可关联多个TODO
      sureRelated() {
        if (this.resolveSelected('more')) {
          if (!this.contractId) return;
          console.log('sureRelated');
          let ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          const params = {
            id: this.contractId,
            relateIds: ids,
          };
          this.$axios.post(API.RELATE_CONTRACT, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg || '操作成功',
                type: 'success',
              });
              this.$emit('close', 'refresh');
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg || '操作失败',
                type: 'error',
              });
            }
          });
        }
      },
      // 是否选择数据
      resolveSelected(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: '请选择数据！',
            type: 'warning',
          });
          return false;
        } else if (this.multipleSelection.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: '请选择一条数据！',
            type: 'warning',
          });
          return false;
        }
        return true;
      },
      resetBtnClick() {
        console.log('resetBtnClick');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      search() {
        console.log('search');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      getData() {
        // this.checkedRowKeys = [];
        // this.multipleSelection = [];
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.dialogQuery, pageNum, pageSize };
        params.notInId = this.contractId;
        params.contractCompanyNo = this.userInfo.companyCode;
        this.$axios.post(API.RELATED_CONTRACT_LIST_PAGE, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.records || [];
            this.tableData.forEach((item) => {
              item.auditStatusName = this.transferSelect(item.auditStatus, this.auditStatusList);
              item.contractStatusName = this.transferSelect(
                item.contractStatus,
                this.contractStatusList
              );
              item.leaseDuration =
                item.leaseDateFrom && item.leaseDateUntil
                  ? `${(item.leaseDateFrom || '').replaceAll('-', '.')}-${(
                      item.leaseDateUntil || ''
                    ).replaceAll('-', '.')}`
                  : '';
              // if (item.related) {
              //   console.log(item, '12345');
              //   this.$nextTick(() => {
              //     this.checkedRowKeys.push(item.id);
              //     this.multipleSelection.push(item);
              //   });
              //   console.log(this.checkedRowKeys, 'checkedRowKeys');
              //   console.log(this.multipleSelection, 'multipleSelection');
              // }
            });
            // this.tableData = this.tableData.filter((item) => !item.related);
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      handleSizeChange() {
        this.getData();
      },
      handleCurrentChange() {
        this.getData();
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      cellClick(val) {
        if (val.column?.property === 'contractNo') {
          const path = {
            path: 'propert/detailLeaseContract',
            name: 'detailLeaseContract',
            meta: {
              keepAlive: true,
              title: '租赁合同详情',
            },
            query: {
              type: 'detail',
              contractId: val.row.id,
            },
          };
          this.$router.push(path);
        }
      },
      cellStyle({ column }) {
        if (column.property == 'contractNo') {
          // console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
          };
        }
      },
    },
  };
</script>
